import { useState, useEffect } from 'react';
import { apiClient } from '../api/client';

interface UserQuota {
  user_id: string;
  email: string;
  enabled: boolean;
  quota_used: number;
  quota_max: number;
  percentage: number;
  status: 'OK' | 'WARNING' | 'EXCEEDED';
}

interface ApiQuota {
  api: string;
  total_users: number;
  quota_used: number;
  quota_max: number;
  usage_percent: number;
  status: 'OK' | 'WARNING' | 'EXCEEDED';
  users_ok: number;
  users_warning: number;
  users_exceeded: number;
  users: UserQuota[];
}

export interface DailyPoint {
  date: string;
  count: number;
}

export interface APIActivity {
  api: string;
  days: DailyPoint[];
}

interface QuotasResponse {
  apis: ApiQuota[];
  activity: APIActivity[];
}

export const useQuotas = () => {
  const [quotas, setQuotas] = useState<ApiQuota[]>([]);
  const [activity, setActivity] = useState<APIActivity[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchQuotas = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await apiClient.get<QuotasResponse>('/v1/dashboard/quotas');
      setQuotas(response.data.apis);
      setActivity(response.data.activity || []);
    } catch (err: any) {
      setError(err.message || 'Erreur lors du chargement des quotas');
      console.error('Erreur fetch quotas:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchQuotas();
  }, []);

  return { quotas, activity, loading, error, refetch: fetchQuotas };
};
